import { render, staticRenderFns } from "./IeltsDetail.vue?vue&type=template&id=19636edc&scoped=true"
import script from "./IeltsDetail.vue?vue&type=script&lang=js"
export * from "./IeltsDetail.vue?vue&type=script&lang=js"
import style0 from "./IeltsDetail.vue?vue&type=style&index=0&id=19636edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19636edc",
  null
  
)

export default component.exports